<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005444')">
              <morePlatforms
                :platformList="platformList"
                :dataSource="true"
                :defaultPlatform="defaultPlatform"
                @selectPlatform="selectPlatform">
              </morePlatforms>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1007137')" prop="code">
              <Input :placeholder="$t('key1007138')" v-model.trim="pageParams.code" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1007139')" prop="name">
              <Input :placeholder="$t('key1007140')" v-model.trim="pageParams.name" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005430')" prop="platformAccountStatus">
              <Select v-model="pageParams.platformAccountStatus" :placeholder="$t('key1000110')">
                <Option v-for="item in authorizationStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1007141')">
              <Date-picker
                style="width:100%"
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="expirationTimeArr">
              </Date-picker>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" class="mr15" @click="authorizedOperation(pageParams.platformId)">{{ $t('key1001329') }}</Button>
      <!--YMS-11993需求调整需要暂时屏蔽掉-->
      <!--<Button class="mr15" type="primary" @click="openAuthorizedStore">管理已授权店铺</Button>-->
      <Button class="mr15" type="primary" v-if="pageParams.platformId === 'jushuitan'"
        @click="$refs.inventorySyncRules.getInventorySyncRules()">{{ $t('key1005619') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        :loading="tableLoading"
        border
        max-height="460"
        :columns="tableColumn"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--管理已授权店铺弹窗-->
    <authorizedStore ref="authorizedStore" @getList="search"></authorizedStore>
    <!--聚水潭平台--库存同步规则弹窗-->
    <inventorySyncRulesModal ref="inventorySyncRules"></inventorySyncRulesModal>
    <!--同步仓库库存弹窗-->
    <synchronizeWarehouseInventoryModal
      ref="synchronizeWarehouseInventory"
      @updateData="pageParamsStatus = true">
    </synchronizeWarehouseInventoryModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import morePlatforms from "@/components/common/morePlatforms";
import authorizedStore from "@/components/common/authorizedStore";
import inventorySyncRulesModal from "@/views/supplier/components/thirdPartyPlatform/inventorySyncRulesModal";
import synchronizeWarehouseInventoryModal from "@/views/supplier/components/thirdPartyPlatform/synchronizeWarehouseInventoryModal.vue";
import {commonLocalStorage} from "@/utils/common";

export default {
  name: "platformAuthorization",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        platformId: null,
        code: '',
        name: '',
        invalidStartTime: null,
        invalidEndTime: null,
        platformAccountStatus: 'null',
        pageSize: 15,
        pageNum: 1
      },
      tableColumn: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793'),
          key: 'platformId',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let platformName = '';
            let platformId = params.row.platformId;
            if (v.platformList.length > 0) {
              v.platformList.map((item) => {
                if (item.platformId === platformId) {
                  platformName = item.platformName;
                }
              })
            }
            return h('span', platformName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001324'),
          key: 'code',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007132'),
          key: 'name',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005821'),
          key: 'authorizationStatus',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let isShopeeChildAccount = !!(params.row.parentYmsPlatformAccountId && params.row.platformId === 'shopee'); // 是否为shopee子账号
            if (params.row.ymsPlatformAccountTokens) {
              let data = params.row.ymsPlatformAccountTokens;
              if (data) {
                return h('div', data.map(i => {
                  return h('p', {class: 'flex align-items-center flex-wrap'}, [
                    h('span', {
                      domProps: {
                        title: i.authName,
                      }
                    }, i.authName),
                    h('span', {
                      style: {
                        color: i.status === 1 ? 'green' : 'red'
                      },
                      class: 'ml5 mr5',
                    }, i.status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001326') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001327')),
                    (i.authDescription && !isShopeeChildAccount) ? h('Poptip', {
                      props: {
                        'word-wrap': true,
                        trigger: 'hover',
                        content: i.authDescription
                      }
                    }, [h('Icon', {
                      props: {
                        size: 16,
                        type: 'ios-help-circle'
                      }
                    })]) : '',
                    (!isShopeeChildAccount && i.authType.includes('oauth') && v.getPermission('ymsPlatformAccount_applyAuth')) ? h('span', {
                      class: 'goAuth',
                      on: {
                        'click'() {
                          v.editStoreBtn(params.row.platformId, params.row.ymsPlatformAccountId, i.authType, 'toauth');
                        }
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005822')) : ''
                  ]);
                }));
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007133'),
          key: 'authorizationTime',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.authorizationTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005826'),
          key: 'accessTokenInvalidTime',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.accessTokenInvalidTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002157'),
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let status = params.row.status;
            return status === 0 ? h('span', {
              class: 'stopStatus'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')) : h('span', {
              class: 'openStatus'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007134'),
          key: 'synchronization',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            let status = params.row.authorizationStatus;
            let platformId = params.row.platformId;
            let synchronizationTypeList = [];
            let keyList = [];
            let obj = params.row;
            for (let key in obj) {
              keyList.push(key);
            }

            // 聚水潭、ERP2.0的库存
            let stockObj = h('Checkbox', {
              props: {
                value: params.row.inventorySync === 1
              },
              style: {
                marginLeft: '10px',
                marginRight: 0
              },
              on: {
                'on-change'(val) {
                  v.tableData.map((ele) => {
                    v.$set(ele, 'inventorySync', 0)
                  })
                  let value = val ? 1 : 0;
                  v.$set(v.tableData[params.index], 'inventorySync', value);
                  v.handerSynchronization('inventorySync', value, params.row.ymsPlatformAccountId);
                }
              }
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000890'));

            // 1688平台(以后通用的平台)
            v.dataSyncList.map((item) => {
              if (keyList.includes(item.type)) {
                synchronizationTypeList.push(
                  h('Checkbox', {
                    props: {
                      value: params.row[item.type],
                      trueValue: 'Y',
                      falseValue: 'N'
                    },
                    style: {
                      marginLeft: '10px',
                      marginRight: 0
                    },
                    on: {
                      'on-change'(val) {
                        v.tableData.map((ele) => {
                          ele[item.type] = 'N';
                        });
                        v.$set(v.tableData[params.index], item.type, val);
                        setTimeout(() => {
                          v.save1688SyncSettings(params.index);
                        }, 1500);
                      }
                    }
                  }, item.name)
                )
              }
            });
            let synchronizationList = h('div', {class: 'flex align-items-center'}, synchronizationTypeList)

            return status === 1 ? h('div', {
                class: 'flex flex-wrap justify-content-center align-items-center'
              },
              [
                // 聚水潭、ERP2.0 走原来的库存设置（通过inventorySync字段判断）,1688平台（走通用的设置）以后的平台都走这个默认通用设置
                ['jushuitan', 'tongtoolERP2'].includes(platformId) ? stockObj : synchronizationList,
                // 多个仓库库存, EERP2.0 同步库存需要选择仓库
                platformId === 'tongtoolERP2' ? h('span',
                  {
                    class: 'cursor themeColor ml4 font-size-12',
                    on: {
                      click() {
                        v.$refs['synchronizeWarehouseInventory'].initSynchronizeWarehouseInventoryData(params.row)
                      }
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002462')) : ''
              ]
            ) : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          fixed: 'right',
          width: 180,
          render: (h, params) => {
            let authorizationStatus = params.row.authorizationStatus;
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005434'),
                    show: authorizationStatus === 1 && v.getPermission('ymsPlatformAccount_applyAuth'),
                    clickFn: () => {
                      v.authorizeBtn(params.row.platformId, params.row.ymsPlatformAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007135'),
                    show: authorizationStatus !== 1 && v.getPermission('ymsPlatformAccount_applyAuth'),
                    clickFn: () => {
                      v.authorizeBtn(params.row.platformId, params.row.ymsPlatformAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsPlatformAccount_enable'),
                    clickFn: () => {
                      v.enableOrDisablePlatform('enable', params.row.ymsPlatformAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsPlatformAccount_disable'),
                    clickFn: () => {
                      v.enableOrDisablePlatform('disable', params.row.ymsPlatformAccountId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      total: 0,
      platformList: [],
      authorizationStatusList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005436')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005437')}
      ],
      expirationTimeArr: [],
      dataSyncList: [
        {type: 'alibabaProductSync', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007136'), value: 'N'},
        {type: 'alibabaInventorySync', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000890'), value: 'N'}
      ],
      defaultPlatform: '',
    }
  },
  created() {
    this.initFun();
  },
beforeDestroy() {
    this._isDestroyed = true;
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.initWebSocket();
        await this.getYmsThirdPlatformData();
      })();
    },
    /**
     * 注册第三方平台授权结果使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
v.webSocketListenerKey = `platform-authorization-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data) {
          if (data.type === 'auth') {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005832'));
          } else if (data.type === 'save') {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005833'));
          }
          v.pageParamsStatus = true;
        }
      }, v);
    },

    /**
     * 清理第三方平台授权结果监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 编辑店铺
    editStoreBtn(platformId, ymsPlatformAccountId, authType, action) {
      this.authorizedOperation(platformId, ymsPlatformAccountId, authType, action);
    },
    // 获取第三方平台数据
    getYmsThirdPlatformData() {
      let v = this;
      let obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      let supplierPlatformList = obj?.suppliePlatformSet ?? [];
      return new Promise((resolve) => {
        if (supplierPlatformList.length > 0) {
          v.axios.get(api.get_ymsThirdPlatform_query).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              let newData = data.filter((item) => {
                return supplierPlatformList.includes(item.platformId);
              });
              newData.map((item) => {
                item.name = item.platformName;
              });
              v.platformList = newData;
              if (v.platformList.length > 0) {
                v.pageParams.platformId = v.platformList[0].platformId || null;
                v.defaultPlatform = v.platformList[0].platformId;
                v.getList();
              }
              resolve(newData);
            }
          });
        } else {
          resolve([]);
        }
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.platformId = v.defaultPlatform;
      v.expirationTimeArr = [];
      v.resetDate();
      v.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPlatformAccount_query')) {
        v.tableLoading = true;
        let query = JSON.parse(JSON.stringify(v.pageParams));
        if (v.pageParams.platformAccountStatus === 'null') {
          query.platformAccountStatus = null;
        }
        v.axios.post(api.post_ymsPlatformAccount_query, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let newList = data.list || [];
            if (newList.length > 0) {
              newList.map((item) => {
                item['authorizationTime'] = null;
                item['accessTokenInvalidTime'] = null;
                item['authorizationStatus'] = 0;
                if (item.ymsPlatformAccountTokens && item.ymsPlatformAccountTokens.length > 0) {
                  // 1688平台
                  if (query.platformId === 'alibaba') {
                    let list = item.ymsPlatformAccountTokens.filter((ele) => {
                      return ele.authType === 'oauth1'
                    });
                    if (list.length > 0) {
                      item['authorizationStatus'] = list[0].status;
                      item['authorizationTime'] = list[0].updatedTime;
                      item['accessTokenInvalidTime'] = list[0].refreshTokenInvalidTime;
                    }
                  }
                  // 其他平台
                  else {
                    item['authorizationStatus'] = item.ymsPlatformAccountTokens[0].status;
                    item['authorizationTime'] = item.ymsPlatformAccountTokens[0].updatedTime;
                    item['accessTokenInvalidTime'] = item.ymsPlatformAccountTokens[0].accessTokenInvalidTime;
                  }
                }
                v.dataSyncList.map((ele) => {
                  item[ele.type] = ele.value;
                });
              });
              v.getSyncSettings(newList);
            } else {
              v.tableLoading = false;
            }
            v.total = data.total;
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取对应平台下的数据同步的设置
    getSyncSettings(list) {
      let v = this;
      let talg = ['alibaba'].includes(v.pageParams.platformId);
      if (talg) {
        let query = {
          typeList: [v.pageParams.platformId]
        };
        v.axios.post(api.post_erpCommonSettingParam_queryPlatformSyncSetting, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length > 0) {
              list.map((item, index) => {
                data.map((ele) => {
                  if (item.thirdAuthAccountId === ele.businessId) {
                    item[ele.paramKey] = ele.paramValue
                  }
                })
              });
            }
            v.tableData = list;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
            v.$forceUpdate();
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.tableData = list;
        v.$nextTick(() => {
          v.tableLoading = false;
        });
      }
    },
    // 重置到期时间
    resetDate() {
      this.pageParams.invalidStartTime = null;
      this.pageParams.invalidEndTime = null;
    },
    // 获取到期时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.invalidStartTime = null;
          v.pageParams.invalidEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.expirationTimeArr = v.defaultTimePeriod(value, false);
          v.pageParams.invalidStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.invalidEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 启用、停用平台
    enableOrDisablePlatform(type, ymsPlatformAccountId) {
      let url = '';
      let text = '';
      if (type === 'disable') {
        url = api.put_ymsPlatformAccount_disable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472');
      } else {
        url = api.put_ymsPlatformAccount_enable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473');
      }
      this.axios.put(url, ymsPlatformAccountId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.pageParamsStatus = true;
          this.$Message.success(text);
        }
      });
    },
    // 授权、重新授权
    authorizeBtn(platformId, ymsPlatformAccountId, authType, action) {
      this.authorizedOperation(platformId, ymsPlatformAccountId, authType, action);
    },
    // 授权、重新授权需要调申请授权接口重定向到三方授权系统进行操作
    authorizedOperation(platformId, ymsPlatformAccountId = null, authType = '', action = 'edit') {
      let v = this;
      let query = {
        "action": action, // 行动(toauth(返回授权地址)、edit(返回表单地址))
        "ymsPlatformAccountId": ymsPlatformAccountId, // 授权账号TOKEN流水号
        "currentAuthType": authType,
        "platformId": platformId
      }
      if (['alibaba'].includes(platformId)) {
        query.authTypes = ['oauth2'];
      }
      v.axios.post(api.post_ymsPlatformAccount_applyAuth, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            window.open(data.redirectUrl, '_blank');
          } else {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005425'));
            return false;
          }
        }
      });
    },
    // 处理数据同步 --（库存同步）
    handerSynchronization(type, value, ymsPlatformAccountId) {
      let v = this;
      let query = {
        [type]: value,
        ymsPlatformAccountId: ymsPlatformAccountId
      };
      v.axios.put(api.put_ymsPlatformAccount_type + `${type}`, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 选取平台
    selectPlatform(platformId) {
      this.pageParams.platformId = platformId;
      this.pageParamsStatus = true;
    },
    // 管理已授权店铺
    openAuthorizedStore() {
      this.$refs['authorizedStore'].getAuthorizedStore({
        platformId: this.pageParams.platformId
      });
    },
    // 1688平台数据同步
    save1688SyncSettings(currentIndex) {
      let v = this;
      let paramBoList = [];
      v.tableData.map((item, index) => {
        if (index === currentIndex) {
          v.dataSyncList.map((ele) => {
            paramBoList.push({
              businessId: item.thirdAuthAccountId,
              paramKey: ele.type,
              paramValue: item[ele.type],
            })
          })
        }
      })
      let query = {
        paramBoList: paramBoList
      };
      v.axios.post(api.post_erpCommonSettingParam_saveAlibabaSyncSetting, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.pageParamsStatus = true;
        }
      });
    },
  },
  components: {
    morePlatforms,
    authorizedStore,
    inventorySyncRulesModal,
    synchronizeWarehouseInventoryModal
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
}
</script>

<style lang="less">
.synchronous_warehouse_box_style {
  width: 300px;

  .ivu-poptip-body {
    padding: 0;
    max-height: 300px;
    overflow-y: auto;

    .ivu-icon-ios-help-circle {
      display: none;
    }

    .ivu-poptip-body-message {
      padding: 0;
    }

    .synchronous_warehouse_title {
      padding: 8px 0 8px 12px;
      border-bottom: 1px solid #EEEEEE;
      font-size: 13px;
      color: #333;
    }

    .synchronous_warehouse_conent {
      padding: 0 0 0 18px;
    }

    .ivu-checkbox {
      margin-right: 5px;
    }

    .ivu-alert-warning {
      font-size: 12px;
      color: #666;
      border: none;
      background-color: transparent;
    }
  }

  .ivu-poptip-footer {
    border-top: 1px solid #EEEEEE;
    padding: 12px 15px 12px 0;
  }
}

.goAuth {
  color: #2D8CF0;
  cursor: pointer;
  white-space: nowrap;
}

.goAuth:hover {
  text-decoration: underline;
}
</style>
